export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox',
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio',
  },
  {
    title: that.$l('batch_label_orderBatchNo') || '交货批次号',
    field: 'orderBatchNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('batch_label_identifyNo') || '批次识别单号',
    field: 'identifyNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('batch_label_deliveryDate') || '出货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('batch_label_outBillType') || '出单类型',
    field: 'v_outBillType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('batch_label_dispatchPort') || '发运港口',
    field: 'v_dispatchPort',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('batch_label_destinationPort') || '目的港口',
    field: 'v_destinationPort',
    headerAlign: 'center',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
